export const FAQs = [
    {
        id: "7d8fs8f7s4",
        ques: "How To Register?",
        ans: "You have to fill all the required filled while registering your account like Sponsor ID, Full Name, Email ID, Mobile Number, Password, etc. And after that, you will receive an OTP in your registered email and after confirming the OTP you will receive a confirmation letter via email with your ID and details."
    },
    {
        id: "788sfd5sf4d",
        ques: "What is the package amount?",
        ans: "1st package start with 25$."
    },
    {
        id: "tsufjsj8df7s7",
        ques: "How i will get the withdraw?",
        ans: "You will get withdraw in your TRX wallet."
    },
    {
        id: "usjf8d7f8s",
        ques: "what is the minimum withdraw amount?",
        ans: "Minimum withdraw is 25$."
    },
]